import { useAppSelector } from '../../../app/hooks'
import { selectActiveMap } from '../../../features/maps/mapsSlice'
import { ColorMode, HaloSize } from '../../../shared/types'
import { geoToPixel } from '../../../shared/utils/geoToPixel.utils'
import { UserPointProps } from './types'

import styles from './UserPoint.module.scss'

const useUserPoint = ({
  mapBounds,
  imageWidth,
  imageHeight,
}: UserPointProps) => {
  const userCoords = useAppSelector((state) => state.userLocation.coords)

  let placement: { x: number; y: number } | null = null

  // =======================
  // Selectors
  // =======================
  const activeMap = useAppSelector(selectActiveMap)

  if (userCoords) {
    const { lat, long } = userCoords

    placement = geoToPixel(
      lat,
      long,
      {
        north: mapBounds.north,
        south: mapBounds.south,
        east: mapBounds.east,
        west: mapBounds.west,
      },
      imageWidth,
      imageHeight
    )
  }

  const haloColorStyle =
    activeMap?.color === ColorMode.Dark ? styles.light : styles.dark

  const haloSizeStyle = styles[activeMap?.haloSize ?? HaloSize.Medium]

  return {
    placement,
    haloSizeStyle,
    haloColorStyle,
  }
}

export default useUserPoint
